import Button from "@/components/Button/Button"
import CardFan from "@/components/CardFan/CardFan"
import GoogleIcon from "@/components/GoogleIcon/GoogleIcon"
import GridBackdrop from "@/components/GridBackdrop/GridBackdrop"
import LokaMark from "@/components/LokaMark/LokaMark"
import { FACILITATOR_AUTH_REQUIRED, FACILITATOR_DOMAIN } from "@/lib/firebase/auth"
import { useAuthStore } from "@/store/authStore"
import { selectAuthError, selectAuthPending } from "@/store/authStore"
import { signIn } from "@/store/authSync"
import styles from "@/styles/pages/SignIn.module.css"

/**
 * The way into the facilitator's workspace.
 *
 * Not a route: it is what `FacilitatorOnly` renders instead of the screen you
 * asked for, so the address bar still holds the customer or session you were
 * heading to and signing in lands you there rather than back at the root.
 */
export default function SignIn() {
  const pending = useAuthStore(selectAuthPending)
  const error = useAuthStore(selectAuthError)

  return (
    <div className={styles.page}>
      <GridBackdrop />
      <LokaMark className={styles.mark} />

      <div className={styles.content}>
        <h1 className={styles.title}>Sign in to run a Session</h1>
        <p className={styles.detail}>
          {FACILITATOR_AUTH_REQUIRED ? (
            <>
              Facilitators sign in with their {FACILITATOR_DOMAIN} Google account.
              <br />
              Guests do not sign in — they join with the link you share
            </>
          ) : (
            "Sign-in is switched off in this build, so this continues as a local stand-in facilitator."
          )}
        </p>

        {error ? <pre className={styles.raw}>{error}</pre> : null}

        {/* No popup to open when sign-in is off, and a button that says otherwise
            is the kind of thing this screen is being reviewed for. */}
        {/* `loading` disables it as well, so the popup cannot be asked for twice. */}
        <Button loading={pending} onClick={() => void signIn()}>
          {FACILITATOR_AUTH_REQUIRED && !pending ? <GoogleIcon /> : null}
          {!FACILITATOR_AUTH_REQUIRED
            ? "Continue"
            : pending
              ? "Opening Google…"
              : "Continue with Google"}
        </Button>
      </div>

      <CardFan />
    </div>
  )
}
